import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    const token = localStorage.getItem('token');

    if (!token) {
      this.router.navigate(['/logincubeworks']);
      return false;
    }

    // Si el token es JWT, verificar que no haya expirado
    try {
      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
          localStorage.clear();
          this.router.navigate(['/logincubeworks']);
          return false;
        }
      }
    } catch {
      // Token no es JWT o está malformado — se permite el acceso
      // (el servidor rechazará las peticiones si el token es inválido)
    }

    return true;
  }
}
